(function () {
  'use strict';
  if (window.AUVENNEWinnerCroBound) return;
  window.AUVENNEWinnerCroBound = true;

  function isSwedish() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0;
  }

  function ui(nl, sv) {
    return isSwedish() ? sv : nl;
  }

  function rootPath() {
    var value = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return value.charAt(value.length - 1) === '/' ? value : value + '/';
  }

  function helpPath(anchor) {
    return rootPath() + 'pages/' + (isSwedish() ? 'kundservice' : 'klantenservice') + anchor;
  }

  function bagIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.8 8.5h10.4l1 11H5.8l1-11Z"></path><path d="M9 9V7a3 3 0 0 1 6 0v2"></path><path d="M12 12.5v4"></path><path d="M10 14.5h4"></path></svg>';
  }

  function enhanceCollection() {
    var root = document.querySelector('.lu-collection-body');
    if (!root) return;
    var toolbar = root.querySelector('.lu-toolbar');
    var hasEligibleProducts = root.querySelector('.auv-combi-participant');

    if (toolbar && hasEligibleProducts && !root.querySelector('[data-auv-collection-offer]')) {
      var offer = document.createElement('aside');
      offer.className = 'auv-collection-offer';
      offer.setAttribute('data-auv-collection-offer', '');
      offer.setAttribute('aria-label', ui('Combinatiekorting', 'Kombinationsrabatt'));

      var mark = document.createElement('span');
      mark.className = 'auv-collection-offer__mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = '2+';

      var copy = document.createElement('span');
      copy.className = 'auv-collection-offer__copy';
      var eyebrow = document.createElement('span');
      eyebrow.className = 'auv-collection-offer__eyebrow';
      eyebrow.textContent = ui('COMBINEER JE FAVORIETEN', 'KOMBINERA DINA FAVORITER');
      var strong = document.createElement('strong');
      strong.textContent = ui('2 sieraden = 15% · 3 sieraden = 25%', '2 smycken = 15% · 3 smycken = 25%');
      copy.appendChild(eyebrow);
      copy.appendChild(strong);

      var automatic = document.createElement('span');
      automatic.className = 'auv-collection-offer__automatic';
      automatic.textContent = ui('Automatisch', 'Automatiskt');

      offer.appendChild(mark);
      offer.appendChild(copy);
      offer.appendChild(automatic);
      toolbar.insertAdjacentElement('afterend', offer);
    }

    root.querySelectorAll('.auv-card__quick[data-auv-quick-add]').forEach(function (button) {
      if (button.getAttribute('data-auv-winner-icon') === 'true') return;
      var fallbackLabel = button.textContent.trim();
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', fallbackLabel);
      if (!button.getAttribute('title')) button.setAttribute('title', fallbackLabel);
      button.innerHTML = bagIcon();
      button.classList.add('auv-winner-icon-action');
      button.setAttribute('data-auv-winner-icon', 'true');
    });
  }

  function proofItems() {
    if (document.querySelector('[data-legame-pdp]')) {
      return [
        { title: ui('Onderhoudsadvies','Skötselråd'), copy: ui('Lees meer bij Goed om te weten','Läs mer under Bra att veta'), href: helpPath('#help-faq') },
        { title: ui('12 maanden kleurgarantie','12 månaders färggaranti'), copy: ui('Voor PVD-sieraden · voorwaarden gelden','För PVD-smycken · villkor gäller'), href: helpPath('#help-faq') },
        { title: ui('Levertijd per product','Leveranstid per produkt'), copy: ui('Verzending berekend bij het afrekenen','Frakt beräknas i kassan'), href: helpPath('#help-shipping') },
        { title: ui('30 dagen retour','30 dagars retur'), copy: ui('60 dagen voor geschikte MY AUVENNE-aankopen','60 dagar för kvalificerade MY AUVENNE-köp'), href: helpPath('#help-return-form') }
      ];
    }
    if (isSwedish()) {
      return [
        { title: 'Material & skötsel', copy: 'Skötselråd för ditt smycke', href: helpPath('#help-faq') },
        { title: '12 månaders färggaranti', copy: 'För PVD-smycken · villkor gäller', href: helpPath('#help-faq') },
        { title: 'Leveranstid per produkt', copy: 'Frakt beräknas i kassan', href: helpPath('#help-shipping') },
        { title: '30 dagars retur', copy: '60 dagar för kvalificerade MY AUVENNE-köp', href: helpPath('#help-return-form') }
      ];
    }
    return [
      { title: 'Materiaal & verzorging', copy: 'Verzorgingsadvies bij je sieraad', href: helpPath('#help-faq') },
      { title: '12 maanden kleurgarantie', copy: 'Voor PVD-sieraden · voorwaarden gelden', href: helpPath('#help-faq') },
      { title: 'Levertijd per product', copy: '€4,95 · gratis vanaf €45', href: helpPath('#help-shipping') },
      { title: '30 dagen retour', copy: '60 dagen voor geschikte MY AUVENNE-aankopen', href: helpPath('#help-return-form') }
    ];
  }

  function buildProof(buy, actions) {
    var proof = buy.querySelector('[data-auv-winner-proof]');
    if (!proof) {
      proof = document.createElement('section');
      proof.className = 'auv-winner-proof';
      proof.setAttribute('data-auv-winner-proof', '');
      proof.setAttribute('aria-label', ui('Waarom je zeker bestelt bij AUVENNE', 'Därför kan du känna dig trygg hos AUVENNE'));

      var title = document.createElement('p');
      title.className = 'auv-winner-proof__title';
      title.textContent = ui('AUVENNE ZEKERHEID', 'TRYGGT MED AUVENNE');

      var grid = document.createElement('div');
      grid.className = 'auv-winner-proof__grid';
      proofItems().forEach(function (item) {
        var link = document.createElement('a');
        link.className = 'auv-winner-proof__item';
        link.href = item.href;
        var strong = document.createElement('strong');
        strong.textContent = item.title;
        var copy = document.createElement('span');
        copy.textContent = item.copy;
        link.appendChild(strong);
        link.appendChild(copy);
        grid.appendChild(link);
      });

      proof.appendChild(title);
      proof.appendChild(grid);
    }

    var express = buy.querySelector('[data-auv-express-copy]');
    var anchor = express || actions;
    if (anchor.nextElementSibling !== proof) anchor.insertAdjacentElement('afterend', proof);
    return proof;
  }

  function currentHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function productJson(handle) {
    return fetch(rootPath() + 'products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product');
      return response.json();
    });
  }

  function availableVariant(product) {
    return (product.variants || []).find(function (variant) { return variant.available; }) || (product.variants || [])[0];
  }

  function imageUrl(product, variant) {
    if (variant && variant.featured_image) return variant.featured_image.src || variant.featured_image;
    if (product.featured_image) return product.featured_image.src || product.featured_image;
    return product.images && product.images[0] ? product.images[0] : '';
  }

  function money(cents) {
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'EUR';
    try {
      return new Intl.NumberFormat(isSwedish() ? 'sv-SE' : 'nl-NL', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: currency === 'SEK' ? 0 : 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function imageTile(url, alt) {
    var tile = document.createElement('span');
    tile.className = 'auv-winner-combo__image';
    if (url) {
      var image = document.createElement('img');
      image.src = url;
      image.alt = alt;
      image.loading = 'lazy';
      tile.appendChild(image);
    }
    return tile;
  }

  function upgradeCombo(buy, proof) {
    var combo = buy.querySelector('[data-auv-ad-combo]');
    if (!combo || combo.getAttribute('data-auv-winner-combo') === 'true' || combo.getAttribute('data-auv-winner-pending') === 'true') return;
    var handle = currentHandle();
    var partners = {
      'zircon-heart-bracelet': 'ring-with-alternating-hearts-and-cubic-zirconia',
      'ring-with-alternating-hearts-and-cubic-zirconia': 'zircon-heart-bracelet',
      'elegant-bracelet-with-zirconia-set-flowers': 'ring-with-alternating-hearts-and-cubic-zirconia'
    };
    var partnerHandle = partners[handle];
    if (!partnerHandle) return;
    combo.setAttribute('data-auv-winner-pending', 'true');

    Promise.all([productJson(handle), productJson(partnerHandle)]).then(function (products) {
      var current = products[0];
      var partner = products[1];
      var currentVariant = availableVariant(current);
      var partnerVariant = availableVariant(partner);
      if (!currentVariant || !partnerVariant) {
        combo.removeAttribute('data-auv-winner-pending');
        return;
      }

      var media = combo.querySelector('.auv-ad-combo__media');
      if (media) {
        media.innerHTML = '';
        var frame = document.createElement('span');
        frame.className = 'auv-winner-combo__media';
        frame.appendChild(imageTile(imageUrl(current, currentVariant), current.title));
        frame.appendChild(imageTile(imageUrl(partner, partnerVariant), partner.title));
        media.appendChild(frame);
      }

      var eyebrow = combo.querySelector('.auv-ad-combo__eyebrow');
      if (eyebrow) eyebrow.textContent = ui('SAMEN GEDRAGEN', 'BÄR DEM TILLSAMMANS');
      var regular = Number(currentVariant.price) + Number(partnerVariant.price);
      var discounted = Math.round(regular * .85);
      var saving = combo.querySelector('.auv-ad-combo__saving');
      if (saving) saving.textContent = money(regular) + ' → ' + money(discounted) + ui(' · 15% automatisch', ' · 15% automatiskt');
      var cta = combo.querySelector('.auv-ad-combo__cta');
      if (cta) cta.textContent = ui('Bekijk de combinatie →', 'Se kombinationen →');

      combo.classList.add('auv-winner-combo');
      combo.setAttribute('data-auv-winner-combo', 'true');
      combo.removeAttribute('data-auv-winner-pending');
      if (proof.nextElementSibling !== combo) proof.insertAdjacentElement('afterend', combo);
    }).catch(function () {
      combo.removeAttribute('data-auv-winner-pending');
    });
  }

  function enhancePdp() {
    var root = document.querySelector('[data-lu-pdp]');
    if (!root) return;
    var buy = root.querySelector('.lu-pdp__buy');
    var actions = buy && buy.querySelector('.lu-pdp__actions');
    if (!buy || !actions) return;

    var sharedProof = buy.querySelector('.auv-pdp-cta-proof');
    buy.querySelectorAll('.auv-pdp__trust, [data-auv-winner-proof]').forEach(function (trust) {
      if (sharedProof && trust !== sharedProof) trust.remove();
      else {
        trust.setAttribute('data-auv-winner-replaced', 'true');
        trust.setAttribute('aria-hidden', 'true');
      }
    });

    var proof = sharedProof || buildProof(buy, actions);
    var payments = buy.querySelector('.lu-pdp__payments');
    if (payments && proof.nextElementSibling !== payments && !buy.querySelector('[data-auv-ad-combo]')) {
      proof.insertAdjacentElement('afterend', payments);
    }
    upgradeCombo(buy, proof);
  }

  function enhance() {
    enhanceCollection();
    enhancePdp();
  }

  function schedule() {
    enhance();
    window.setTimeout(enhance, 180);
    window.setTimeout(enhance, 650);
    window.setTimeout(enhance, 1400);
    window.setTimeout(enhance, 2600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
})();


